import { BasicCardVariantType } from '../../../../../../components/basicCard/types/basicCard';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../variants';
import { firstContainerCommonStyles, parentContainerCommonStyles } from '../commonStyles';
export const getRegularDefaultStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [BasicCardVariantType.REGULAR_DEFAULT]: {
            parentContainer: {
                ...parentContainerCommonStyles(FOUNDATIONS, SHADOWS),
                background_color: FOUNDATIONS.color_neutral_bg_800,
            },
            label: {
                font_variant: TextVariantType.FONT_PARAGRAPH_350,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_100,
            },
            title: {
                font_variant: TextVariantType.FONT_PARAGRAPH_250,
                font_weight: FONT_WEIGHT.font_weight_600,
                color: FOUNDATIONS.color_neutral_font_50,
            },
            subtitle: {
                font_variant: TextVariantType.FONT_PARAGRAPH_350,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_neutral_font_100,
            },
            firstContainer: {
                ...firstContainerCommonStyles(FOUNDATIONS, FONT),
                background_color: FOUNDATIONS.color_neutral_bg_800,
            },
            secondContainer: {
                background_color: FOUNDATIONS.color_neutral_bg_800,
            },
        },
    };
};
//# sourceMappingURL=regularDefault.js.map